// Mapeo tipo de contraparte de gastos → obligación que usa el endpoint de
// metadata del drawer de detalle (HeaderClientDetail/BodyClientDetail).
// Proveedor/Cliente caen al bucket "Otros". Compartido por el ranking del
// modal de análisis (BodyExpensesAnalysis) y el atajo de la tabla (GastosTab),
// para no duplicar el mapa.
export const METADATA_OBLIGATION_BY_TYPE = {
    Honorario: "Boleta de Honorarios",
    Trabajador: "remuneracion-clf",
    Internacional: "invoices-clf",
    Recibo: "recibos-clf",
    Finiquito: "finiquitos-clf",
};

export function obligationForType(counterpartType) {
    return METADATA_OBLIGATION_BY_TYPE[counterpartType] || "Otros";
}
